var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('h1',[_vm._v("Plugins")]),_vm._m(0),_c('section',[(!_vm.removed)?_c('button',{on:{"click":_vm.handleButtonClick}},[_vm._v("删除我")]):_vm._e(),_c('button',{on:{"click":_vm.handleButton2Click}},[_vm._v("👈🏻恢复它")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('code',[_vm._v("this.$confirm()")])])
}]

export { render, staticRenderFns }